export default {
    state: {
        page: 1,
        limit: 50,
        lastPage: null,
        filters: {
            pa_brand: '',
            pa_color: '',
            pa_material: '',
            sort: 'featured',
            cat: '',
            page: 1,
            limit: 50,
        },
        selectedAttributes: {},
        fetchInProgress: false,
        isInitialFetch: true
    },
    getters: {
        getPage: state => state.page,
        getLimit: state => state.limit,
        getFilters: state => state.filters,
        getSelectedAttributes: state => state.selectedAttributes,
        getFetchInProgress: state => state.fetchInProgress,
        getLastPage: state => state.lastPage,
        getIsInitialFetch: state => state.isInitialFetch,
    },
    mutations: {
        SET_PAGE: (state, page) => {
            state.page = page;
        },
        SET_LIMIT: (state, limit) => {
            state.limit = limit;
        },
        SET_FILTERS: (state, filters) => {
            state.filters = filters;
        },
        SET_SELECTED_ATTRIBUTES: (state, selectedAttributes) => {
            state.selectedAttributes = selectedAttributes;
        },
        SET_FETCH_IN_PROGRESS: (state, fetchInProgress) => {
            state.fetchInProgress = fetchInProgress;
        },
        SET_IS_INITIAL_FETCH: (state, isInitialFetch) => {
            state.isInitialFetch = isInitialFetch;
        },
        SET_LAST_PAGE: (state, lastPage) => {
            state.lastPage = lastPage;
        }
    },
    actions: {
        setPage({ commit }, page) {
            commit('SET_PAGE', page);
        },
        setLimit({ commit }, limit) {
            commit('SET_LIMIT', limit);
        },
        setFilters({ commit }, filters) {
            commit('SET_FILTERS', filters);
        },
        setSelectedAttributes({ commit }, selectedAttributes) {
            commit('SET_SELECTED_ATTRIBUTES', selectedAttributes);
        },
        setFetchInProgress({ commit }, fetchInProgress) {
            commit('SET_FETCH_IN_PROGRESS', fetchInProgress);
        },
        setIsInitialFetch({ commit }, isInitialFetch) {
            commit('SET_IS_INITIAL_FETCH', isInitialFetch);
        },
        setLastPage({ commit }, lastPage) {
            commit('SET_LAST_PAGE', lastPage);
        },
    }
};
